import React, { useEffect, useRef, useState } from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import { Field, FieldArray, Form, Formik } from "formik";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import RoomPhotoContainer from "./RoomPhoto/RoomPhotoContainer";
import AutoSaveWithDebounce from "../common/Autosave/AutoSaveWithDebounce";
import { FormControlRoom, GreenCheckbox, useStyles } from "./styles";
import FormControl from "@material-ui/core/FormControl";
import AdditionRoomContainer from "./AdditionRoom/AdditionRoomContainer";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../css/themeButtons";
import Preloader from "../common/Preloader/Preloader";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import * as Yup from "yup";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";
import IconButton from "@material-ui/core/IconButton";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import { ChangeDirtyForm } from "../common/CustomHook/ChangeDirtyFrom";
import { usePrevious } from "../common/CustomHook/usePrevious";

let timer = null;


export const RenderRoomAboutMain = ({
  roomId,
  type,
  count,
  area,
  id,
  name,
  adult,
  additional,
  child,
  typesList,
  handleChangeRoomMain,
  objectAboutMainRef,
  changeDirtyRoomMain
}) => {


  const roomSchema = Yup.object().shape({
    type: Yup.number()
      .required('Обязательно для заполнения'), count: Yup.string()
      .required('Обязательно для заполнения'), adult: Yup.string()
      .required('Обязательно для заполнения'), area: Yup.string()
      .required('Обязательно для заполнения'), name: Yup.string()
      .when('type', {
        is: (type) => type === 6560, then: Yup.string()
          .required('Обязательно для заполнения')
      })
  });

  const classes = useStyles()

  if (!typesList || (!type && !count && !adult && roomId !== "new")) {
    return <Preloader loading={true} text="Загружаем информацию о номере"/>
  }
  return (<div id="room-main" className="section">
    <h5 className="card-title mb-2">Основная информация</h5>
    {id && <p>id: {id}</p>}

    <Formik enableReinitialize

            innerRef={objectAboutMainRef}
            validationSchema={roomSchema}

            onSubmit={(values, form) => {
              handleChangeRoomMain(values, form)
            }}
            initialValues={{
              type: type ? `${type}` : "",
              count: count ? count : "",
              area: area ? area : "",
              id: id ? id : "",
              name: name ? name : "",
              adult: adult ? adult : "",
              additional: additional ? additional : "",
              child: child ? child : "",
            }}
    >
      {({ values, errors, touched, dirty }) => (<Form>
        <ChangeDirtyForm changeDirtyAction={changeDirtyRoomMain}/>
        <div className="row g-2 mb-2">
          <div className="col-md-12 col-xl-4">
            <Field name="type">
              {({ field }) => (<FormControl variant="outlined" size="small" fullWidth
                                            error={Boolean(errors.type && touched.type)}>
                <InputLabel>Тип номера*</InputLabel>
                <Select
                  {...field}
                  label="Тип номера*"
                  MenuProps={{ classes: { paper: classes.menuPaper } }}

                >
                  {typesList && typesList.map(type => <MenuItem key={type.id} className="justify-content-center"
                                                                value={type.id}>
                    {type.value}
                  </MenuItem>)}

                </Select>

                {errors.type && touched.type ?
                  <FormHelperText>{errors.type && touched.type && String(errors.type)}</FormHelperText> : null}
              </FormControl>)}
            </Field>
          </div>
          {values.type == 6560 && <div className="col-md-12 col-xl-4">

            <Field name="name">
              {({ field, form }) => (<TextField
                {...field}
                label="Свой тип номера"
                fullWidth
                size="small"
                variant="outlined"
                error={errors.name && touched.name}
                helperText={errors.name && touched.name && String(errors.name)}
              />)}
            </Field>

          </div>}

        </div>
        <div className="row g-2 mb-2">
          <div className="col-md-6 col-xl-4">
            <Field name="area">
              {({ field, form }) => (<FormControl variant="outlined" fullWidth size="small"
                                                  error={errors.area && touched.area}>
                <InputLabel>Площадь номера</InputLabel>
                <OutlinedInput
                  label="Площадь номера"
                  {...field}
                  type="number"
                  endAdornment={<InputAdornment position="end">м2</InputAdornment>}
                />
                {errors.area && touched.area ?
                  <FormHelperText>{errors.area && touched.area && errors.area}</FormHelperText> : <></>}
              </FormControl>)}
            </Field>
          </div>
          <div className="col-md-6 col-xl-4">
            <Field name="count">
              {({ field, form }) => (<TextField
                {...field}
                label="Количество номеров*"
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                error={Boolean(errors.count && touched.count)}
                helperText={errors.count && touched.count && String(errors.count)}
              />)}
            </Field>
          </div>
        </div>
        <div className="row g-2">

          <div className="col-lg-6 col-xl-4">
            <Field name="adult">
              {({ field, form }) => (<TextField
                {...field}
                label="Основных мест*"
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                error={Boolean(errors.adult && touched.adult)}
                helperText={errors.adult && touched.adult && String(errors.adult)}
              />)}
            </Field>
          </div>
          <div className="col-lg-6 col-xl-4">
            <Field name="additional">
              {({ field, form }) => (<TextField
                {...field}
                label="Доп. мест"
                fullWidth
                size="small"
                type="number"
                variant="outlined"
              />)}
            </Field>
          </div>
          <div className="col-lg-6 col-xl-4">
            <Field name="child">
              {({ field, form }) => (<TextField
                {...field}
                label="Детских мест"
                fullWidth
                size="small"
                type="number"
                variant="outlined"
              />)}
            </Field>
          </div>
        </div>
        <AutoSaveWithDebounce debounceMs={500}/>
      </Form>)}
    </Formik>
    <Typography className="pt-2" display="block" variant="caption">* - пункты обязательные для
      заполнения</Typography>
  </div>)
}

export const RenderRoomAboutAddition = ({ serviceName, serviceItem, handleChangeInRoom, clearServiceItem }) => {
  const [expanded, setExpanded] = useState(false);


  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const preSaveForm = (values) => {
    let filtredTrueCheckbox = values.values.filter(item => item.selected === true)

    let saveArr = []
    filtredTrueCheckbox.map((item) => {
      saveArr.push(item.value)
    })

    handleChangeInRoom({ [serviceName]: saveArr })
  }

  const serviceItemPrev = usePrevious(serviceItem)
  const clearFields = () => {
    if (JSON.stringify(serviceItem) === JSON.stringify(serviceItemPrev)) {
      clearServiceItem(serviceName)
    }
  }

  const buttons = themeButtons();
  return (<Formik enableReinitialize
                  initialValues={serviceItem}
                  onSubmit={preSaveForm}>
    {({ handleSubmit, values }) => (<Form onSubmit={handleSubmit} className="section">
        <FieldArray name={serviceName}>
          {({ insert, remove, push }) => (<div id={serviceName}>
            <h5 className="card-title mb-2">
              {serviceItem.label}
            </h5>

            <div className="row g-3">
              {serviceItem.values && serviceItem.values.slice(0, 8).map((service, index) => <div key={index}
                                                                                                 className="col-12 col-md-6 col-lg-4 col-xxl-3">
                <Field type="checkbox" name={`values.${index}.selected`}>
                  {({ field }) => (<FormControlRoom
                      label={service.label}
                      control={<GreenCheckbox {...field}/>}
                    />

                  )}
                </Field>
              </div>)}
            </div>
            {serviceItem.values.length > 7 && <>
              <Collapse className="mt-3" in={expanded} timeout="auto" unmountOnExit>
                <div className="row g-3">
                  {serviceItem.values && serviceItem.values.slice(8).map((service, index) => <div key={index}
                                                                                                  className="col-12 col-md-6 col-lg-4 col-xxl-3">
                    <Field type="checkbox" name={`values.${index + 8}.selected`}>
                      {({ field }) => (<FormControlRoom
                        label={service.label}
                        control={<GreenCheckbox {...field}/>}
                      />)}
                    </Field>
                  </div>)}
                </div>
              </Collapse>
              <div className="col-12 mt-3">
                {expanded ? <Button
                  className={`btn ${buttons.btnLight}`}
                  onClick={handleExpandClick}>
                  Скрыть
                  <FontAwesomeIcon icon={"chevron-up"} className="ms-1"/>
                </Button> : <Button
                  className={`btn ${buttons.btnLight}`}
                  onClick={handleExpandClick}>
                  Показать все
                  <FontAwesomeIcon icon={"chevron-down"} className="ms-1"/>

                </Button>}
              </div>
            </>}
          </div>)}
        </FieldArray>
        <ChangeDirtyForm changeDirtyAction={clearFields}/>
        <AutoSaveWithDebounce debounceMs={10}/>
      </Form>

    )}
  </Formik>)
}


const ObjectRoomEdit = (props) => {
  const [unsavedPage, toggleUnsavedPage] = useState(false)
  const [newRoomId, setNewRoomId] = useState(false)
  const [targetRedirectLink, setTargetRedirectLink] = useState(false)
  const history = useHistory()

  const {
    getRoomById,
    roomMain,
    inRoomServices,
    roomIdByProps,
    getTypeList,
    typesList,
    clearRoom,
    objectId,
    country,
    updateRoom,
    addRoom,
    roomPhotoApprovedToDB,
    roomPhotoNotApprovedToDB,
    getFields,
    getRoomsList
  } = props
  const roomId = props.match.params.roomId

  //реф форм основной информации о номере
  const objectAboutMainRef = useRef()

  const [presavePage, setPresavePage] = useState({})
  const [uploadNewPhotos, setUploadNewPhotos] = useState([])
  const [errors, setErrors] = useState()

  useEffect(() => {
    return () => {
      clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    if (!typesList) {
      getTypeList()
    }
  }, [getTypeList, typesList])


  useEffect(() => {
    if (objectId && country && roomId === "new") {
      getFields({ object: objectId, country })
    }
  }, [country, getFields, objectId, roomId])

  useEffect(() => {
    if (roomPhotoApprovedToDB) {
      setPresavePage((prev) => ({
        ...prev,
        photos: roomPhotoApprovedToDB,
      }))
    }
  }, [roomPhotoApprovedToDB])

  useEffect(() => {
    if (roomPhotoNotApprovedToDB) {
      setPresavePage((prev) => ({
        ...prev,
        rejectedPhotos: roomPhotoNotApprovedToDB,
      }))
    }
  }, [roomPhotoNotApprovedToDB])


  useEffect(() => {
    if (roomId === "new") {
      clearRoom()
    }

    if ((roomIdByProps !== roomId) && (roomId !== "new")) {
      clearRoom()
      getRoomById({ room: roomId })
      window.scrollTo(0, 0)
    }

  }, [clearRoom, getRoomById, roomId, roomIdByProps])


  const handleChangeRoomMain = (values) => {
    toggleUnsavedPage(true)
    setPresavePage(prev => {
      return { ...prev, mainInfo: values }
    })

    if (values.type && values.count && values.adult) {
      setErrors((prev) => {
        return { ...prev, mainInfo: undefined }
      })
    }

  }

  const changeDirtyRoomMain = () => {
    let presavePageCopy = { ...presavePage }
    delete presavePageCopy.mainInfo

    setPresavePage(presavePageCopy)
    if (Object.keys(presavePageCopy).length === 0) {
      toggleUnsavedPage(false)
    }
  }


  /**
   * Изменения загруженных фот
   */
  const handleChangeUploadPhoto = (photosChanged) => {
    let allUploadNewPhotos = [...photosChanged]

    if (presavePage?.deletedPhotos?.length !== 0) {
      allUploadNewPhotos = allUploadNewPhotos.filter((item) => !presavePage?.deletedPhotos?.some((deletedPhoto) => deletedPhoto.includes(item.name)))
    }
    setUploadNewPhotos(() => allUploadNewPhotos)
    toggleUnsavedPage(true)
  }
  /**
   * Изменения фот
   */
  const handleChangePhoto = (photos) => {
    const filtredPhotos = photos.map((item) => {
      let copyItem = { ...item }
      if (presavePage?.deletedPhotos?.includes(String(item.id))) {
        return null
      }
      if (item?.id?.split('-')[0] === 'new') {
        delete copyItem['src']
      }
      return copyItem
    }).filter((item) => !!item)

    setPresavePage((prev) => ({
      ...prev,
      photos: filtredPhotos,
      deletedPhotos: prev?.deletedPhotos?.filter((photoName) => photoName?.includes('new'))
    }))

    toggleUnsavedPage(true)
  }

  const handleChangeRejectedPhoto = (photosChanged) => {
    setPresavePage((prev) => ({
      ...prev,
      rejectedPhotos: photosChanged,
    }))
    toggleUnsavedPage(true)
  }
  const handleChangeDeletedPhoto = (deletedPhotos) => {
    const allDeleted = presavePage?.deletedPhotos ? [...presavePage?.deletedPhotos, ...deletedPhotos] : [...deletedPhotos];
    let allUploadNewPhotos = [...uploadNewPhotos]

    if (allDeleted?.length !== 0) {
      allUploadNewPhotos = allUploadNewPhotos.filter((item) => !allDeleted?.some((deletedPhoto) => deletedPhoto.includes(item.name)))
    }
    setUploadNewPhotos(() => allUploadNewPhotos)

    setPresavePage((prev) => ({
      ...prev,
      deletedPhotos: allDeleted,
    }))

    toggleUnsavedPage(true)
  }

  const handleChangeInRoom = (values) => {
    setPresavePage(prev => {
      return { ...prev, inRoom: { ...prev?.inRoom, ...values } }
    })
    toggleUnsavedPage(true)
  }


  const validatePage = async () => {

    await objectAboutMainRef.current.validateForm()

    objectAboutMainRef.current.setFieldTouched("type")
    objectAboutMainRef.current.setFieldTouched("count")
    objectAboutMainRef.current.setFieldTouched("adult")
    objectAboutMainRef.current.setFieldTouched("area")

    let mainInfo = objectAboutMainRef.current.isValid

    if (!mainInfo) {
      window.scrollTo(0, 0)
      setErrors((prev) => {
        return { ...prev, mainInfo: "Обязательные поля не заполнены" }
      })
      return false
    }

    return true

  }

  //сохранение страницы
  const savePageHandler = async () => {

    let valid = await validatePage()

    if (valid) {
      let response = null
      toggleUnsavedPage(false)


      let formData = new FormData()

      formData.append(`object`, objectId)
      formData.append(`country`, country)

      uploadNewPhotos.forEach((file, i) => {
        formData.append(`uploadPhotos[${i}]`, file, file.name)
      })
      if (roomId === "new") {
        let t = {
          ...presavePage?.mainInfo,
          ...presavePage?.inRoom,
          photos: presavePage?.photos,
          rejectedPhotos: presavePage?.rejectedPhotos,
          deletedPhotos: presavePage?.deletedPhotos,
        }
        formData.append(`fields`, JSON.stringify(t))
        response = await addRoom(formData)
      } else {
        let t = {}
        if (presavePage?.hasOwnProperty("mainInfo")) {
          t = {
            ...presavePage?.mainInfo,
            ...presavePage?.inRoom,
            photos: presavePage?.photos,
            rejectedPhotos: presavePage?.rejectedPhotos,
            deletedPhotos: presavePage?.deletedPhotos,
          }
        } else {
          t = {
            ...roomMain,
            ...presavePage?.inRoom,
            photos: presavePage?.photos,
            rejectedPhotos: presavePage?.rejectedPhotos,
            deletedPhotos: presavePage?.deletedPhotos,
          }
        }
        formData.append(`fields`, JSON.stringify(t))
        formData.append(`room`, roomId)

        response = await updateRoom(formData)
      }

      setPresavePage(null)
      setUploadNewPhotos([])

      if (response) {
        getRoomsList({ object: objectId })
        setErrors((prev) => ({ ...prev, photoSize: null }))

        if (response?.payload?.errors) {
          setErrors((prev) => ({ ...prev, dontUploadPhotos: response?.payload?.errors }))
        }

        if (roomId === "new" && !targetRedirectLink) {
          timer = setTimeout(() => history.push(`/lk/${objectId}/rooms/${response.id}`), 1250)
        }

        if (targetRedirectLink) {
          history.push(targetRedirectLink)
        }
      }
    }

  }


  const clearServiceItem = (serviceName) => {
    if (presavePage && presavePage?.inRoom) {
      let newPresavePage = { ...presavePage }
      delete newPresavePage.inRoom[serviceName]

      if (Object.keys(newPresavePage.inRoom).length === 0) {
        delete newPresavePage.inRoom
      }

      if (Object.keys(newPresavePage).length === 0) {
        toggleUnsavedPage(false)
      }

      setPresavePage(newPresavePage)
    }
  }

  const setSizeAlert = () => {
    setErrors((prev) => {
      return {
        ...prev,
        photoSize: "Вы пытаетесь загрузить большие фотографии (больше 2 МБ), По этой причине процесс загрузки может занять больше времени. Если у Вас слабое интернет-соединение, рекомендуем уменьшить фотографии"
      }
    })
  }

  if (!typesList && !roomMain && !inRoomServices) {
    return <Preloader loading={true} text="Загружаем информацию о номере"/>
  }
  return (<div className="main edit-object">
    <div className="container-fluid">
      {errors && errors.dontUploadPhotos && errors.dontUploadPhotos.map((error, i) => {
        return <div key={error.message} className="alert alert-danger alert-dismiss">
          <div className="">
            <div>{error.message}</div>
            {error.items && <ol>
              {error.items.map(item => <li key={item}>{item}</li>)}
            </ol>}

          </div>

          <IconButton
            onClick={() => setErrors((prev) => {
              let newDontUpload = prev.dontUploadPhotos.filter(item => item.message !== error.message)
              return { ...prev, dontUploadPhotos: newDontUpload }
            })}
            className="alert-dismiss__btn">
            <CloseRoundedIcon/>
          </IconButton>
        </div>

      })}
      <RenderRoomAboutMain {...roomMain} typesList={typesList} roomId={roomId}
                           handleChangeRoomMain={handleChangeRoomMain}
                           changeDirtyRoomMain={changeDirtyRoomMain}
                           setSizeAlert={setSizeAlert} objectAboutMainRef={objectAboutMainRef}/>

      <RoomPhotoContainer roomPhotoApprovedToDB={roomPhotoApprovedToDB}
                          roomPhotoNotApprovedToDB={roomPhotoNotApprovedToDB}
                          errors={errors}
                          handleChangeUploadPhoto={handleChangeUploadPhoto}
                          handleChangePhoto={handleChangePhoto}
                          handleChangeRejectedPhoto={handleChangeRejectedPhoto}
                          handleChangeDeletedPhoto={handleChangeDeletedPhoto}
                          setSizeAlert={setSizeAlert}/>

      {inRoomServices && Object.keys(inRoomServices).map(service => <RenderRoomAboutAddition key={service}
                                                                                             serviceName={service}
                                                                                             clearServiceItem={clearServiceItem}
                                                                                             serviceItem={inRoomServices[service]}
                                                                                             handleChangeInRoom={handleChangeInRoom}/>)}


      <AdditionRoomContainer/>
    </div>


    {unsavedPage && <StickyBottomButton action={savePageHandler}
                                        errors={{ mainInfo: errors?.mainInfo }}/>}

    <AlertSavePage unsavedPage={unsavedPage} btnOkAction={savePageHandler}
                   setTargetRedirectLink={setTargetRedirectLink} targetRedirectLink={targetRedirectLink}/>
    <FunctionSidebarContainer/>
  </div>)
}


export default ObjectRoomEdit
